import Popconfirm from './src/popconfirm.mjs';
export { popconfirmEmits, popconfirmProps } from './src/popconfirm2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElPopconfirm = withInstall(Popconfirm);

export { ElPopconfirm, ElPopconfirm as default };
//# sourceMappingURL=index.mjs.map
